import { ExpandMore } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchVendors } from "../../redux/Catalog/catalogActions";

// For Seeds

const CropCategoryFive = ({ categoryFiveData, setCategoryFiveData }) => {
  const dispatch = useDispatch();
  const { vendors } = useSelector((state) => state.catalog);

  const [isVendorOpen, setIsVendorOpen] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState({});

  const handleSelectedVendor = (data) => {
    setSelectedVendor({
      name: data.name,
      id: data.id,
    });
    setIsVendorOpen(false);
    setCategoryFiveData((prev) => {
      return {
        ...prev,
        vendor: data,
      };
    });
  };

  useEffect(() => {
    dispatch(fetchVendors());
  }, [dispatch]);

  useEffect(() => {
    // Set selected vendor based on categoryFiveData.vendor
    if (categoryFiveData.vendor && vendors?.length > 0) {
      const vendor = vendors.find(
        (v) =>
          v.name === categoryFiveData.vendor.name ||
          v.id === categoryFiveData.vendor.id
      );
      if (vendor) {
        setSelectedVendor(vendor);
      }
    }
  }, [categoryFiveData.vendor, vendors]);
  return (
    <div>
      {" "}
      <div className="relative   rounded-lg bg-white h-fit border border-[#E1E6E1] mt-3">
        <div className="flex flex-col">
          <div className="border-b border-b-[#E1E6E1] px-4 py-3 flex items-center gap-1">
            <p className="text-[#4B564D] font-semibold text-sm">
              Product Details
            </p>
          </div>

          <div className="flex flex-col gap-4 px-4 py-3">
            {/* VENDOR */}
            <div className="relative w-full">
              <div className="flex items-center gap-1 pb-1">
                <p className="text-[#344335] font-normal text-sm leading-[18px]">
                  Vendor
                </p>
              </div>
              <div
                onClick={() => setIsVendorOpen(!isVendorOpen)}
                className="flex justify-between items-center px-[16px] border border-[#96A397] rounded-[8px] h-[44px] w-full cursor-pointer"
              >
                <p className="font-[500] text-sm leading-[20px] capitalize text-[#344335]">
                  {selectedVendor.name || "Select Vendor"}
                </p>
                <ExpandMore
                  className="text-[#ABB6AC] cursor-pointer"
                  style={{ fontSize: "18px" }}
                />
              </div>

              {isVendorOpen && (
                <div className="absolute right-0  w-full rounded-lg  bg-white padding-[8px] mt-[1%] border cursor-pointer py-[8px] mb-[50px] z-20 max-h-[250px] overflow-y-scroll shadow-md">
                  {vendors?.map((data, index) => {
                    return (
                      <p
                        className="py-[12px] px-[16px] text-sm font-medium capitalize leading-5 hover:bg-[#EDF7EE]"
                        key={index}
                        onClick={() => handleSelectedVendor(data)}
                      >
                        {data.name}
                      </p>
                    );
                  })}
                </div>
              )}
            </div>

            <div>
              <div className="flex items-center gap-1 pb-1">
                <p className="text-[#344335] font-normal text-sm leading-[18px]">
                  Seed Rate
                </p>
              </div>
              <input
                type="text"
                placeholder="Seed Rate"
                onChange={(event) =>
                  setCategoryFiveData((prev) => {
                    return {
                      ...prev,
                      seed_rate: event.target.value,
                    };
                  })
                }
                value={categoryFiveData.seed_rate}
                className="outline-none border border-[#96A397] w-full h-[44px] rounded-lg px-3 py-4 placeholder:text-[#96A397] text-sm font-medium leading-5"
              />
            </div>

            <div>
              <div className="flex items-center gap-1 pb-1">
                <p className="text-[#344335] font-normal text-sm leading-[18px]">
                  Adaptability
                </p>
              </div>
              <textarea
                type="text"
                placeholder="Adaptability"
                onChange={(event) =>
                  setCategoryFiveData((prev) => {
                    return {
                      ...prev,
                      adaptability: event.target.value,
                    };
                  })
                }
                value={categoryFiveData.adaptability}
                className="outline-none border border-[#96A397] resize-none w-full h-[134px] rounded-lg px-3 py-4 placeholder:text-[#96A397] text-sm font-medium leading-5"
              />
            </div>

            <div>
              <div className="flex items-center gap-1 pb-1">
                <p className="text-[#344335] font-normal text-sm leading-[18px]">
                  Requirements
                </p>
              </div>
              <textarea
                type="text"
                placeholder="Requirements"
                onChange={(event) =>
                  setCategoryFiveData((prev) => {
                    return {
                      ...prev,
                      requirements: event.target.value,
                    };
                  })
                }
                value={categoryFiveData.requirements}
                className="outline-none border border-[#96A397] resize-none w-full h-[134px] rounded-lg px-3 py-4 placeholder:text-[#96A397] text-sm font-medium leading-5"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CropCategoryFive;
